import React from "react";
import { ENV_DEFAULT_BANK_READER } from "../../../../../../config/envVars";
import { Eurobits } from "./components/Eurobits/Eurobits";
import { Tink } from "./components/Tink/Tink";
import { BankReaderName } from "./types/BankReaderName";

export const BankReaderFactory = ({ onPrev }) => {
  return (
    <>
      {ENV_DEFAULT_BANK_READER === BankReaderName.TINK && (
        <Tink onPrev={onPrev} />
      )}
      {ENV_DEFAULT_BANK_READER === BankReaderName.EUROBITS && (
        <Eurobits onPrev={onPrev} />
      )}
    </>
  );
};
